// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE = "Dni so zna\u010dkou";
export const LIKES_MESSAGE = "sa p\u00e1\u010di spr\u00e1va";
export const LIKES_PROFILE = "si pridala k ob\u013e\u00faben\u00fdm";
export const USER_JOINS_THE_GROUP = "sa stala \u010dlenom skupiny";
